<div *ngIf="uhfSettings.isHeaderRequired && localeTexts.length" id="header" [attr.data-locale]="currentLocale">
    <div class="wrap">
        <div class="hamburgerIco" *ngIf="uhfSettings.linkMenuSection || uhfSettings.languageSection || uhfSettings.currencySection || uhfSettings.footerSection">
            <button class="sidenav-toggle" role="button" (click)="openNewHamburger()" aria-haspopup="true" aria-label="Menu">
                <i class="mat-icon material-icons">menu</i>
            </button>
        </div>
        <aa-uhf-tooltip [isUhf]="true"></aa-uhf-tooltip>
        <div class="userLoginIco" *ngIf="uhfSettings.loginSection">
            <button class="sidenav-toggle" [ngClass]="{ 'iconcolorlogin' : loggedIn, 'iconcolorsignup' : !loggedIn}" (click)="openSsoLogin()" aria-label="User login">
                <i class="mat-icon material-icons">person</i>
            </button>
        </div>
        <div *ngIf="!logoWidth && !logoHeight" class="newLogo">
            <h1 aria-label="AirAsia - Book cheap flights to over 130 destinations" class="logo-head"><a class="aa-logo-link" (keydown)="focusOnSkipToContent($event)" href="{{localeTexts[0].navigation[0].content[0].url}}">
                <img class="aa-logo-image" src="{{activeLogo}}" alt="AirAsia logo">
            </a></h1>
        </div>
        <div *ngIf="logoWidth && logoHeight" class="newLogo" [ngStyle]="{'left': logoWidth <= 140 ? -(logoWidth/2)+'px' : '-70px'}">
            <a class="aa-logo-link" href="{{localeTexts[0].navigation[0].content[0].url}}">
                <img
                    class="aa-logo-image" src="{{activeLogo}}" alt="AirAsia logo"
                    [ngStyle]="{
                        'width': logoWidth <= 140 ? logoWidth+'px' : '140px',
                        'height': logoHeight <= 65 ? logoHeight+'px' : '65px'
                    }">
            </a>
        </div>

        <h2 aria-label="Skip to contents" id="skipContent" class="skip 1" tabindex="0" (keydown)="onEnter($event, compSettingService.waMainContainerId)">Skip to Content</h2>
        <h2 aria-label="Skip to footer" id="skipFooter" class="skip 2" tabindex="0" (keydown)="onEnter($event, compSettingService.waFooterContainerId)">Skip to Footer</h2>

        <div class="menu" *ngIf="uhfSettings.linkMenuSection" [ngClass]="clz0">
            <div class="navMenu-wrapper">
                <ul>
                    <li *ngFor="let item of localeTexts[0].navigation[0].content | slice:1; let i = index;" [attr.data-locale]="currentLocale">
                        <!-- <a *ngIf="i == 0 && isWidgetSync" (click)="openBookingModel($event)" href="{{item.url}}" target="{{item.newTab == 'TRUE' ? '_blank' : ''}}">{{item.text}}</a>
                        <span *ngIf="i == 0 && !isWidgetSync" style="cursor: pointer;">{{item.text}}</span> -->
                        <a href="{{item.url}}" target="{{item.newTab == 'TRUE' ? '_blank' : ''}}">{{item.text}}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="sep s1" *ngIf="uhfSettings.languageSection || uhfSettings.currencySection" [ngClass]="clz0">
        </div>

        <div class="drops" [ngClass]="clz0">
            <span 
                id="langDrop" 
                class="item lang-drop" 
                #langElem 
                (click)="listenersLangCurrLogin($event,'lang')" 
                (keydown)="listenersLangCurrLogin($event,'lang')" 
                *ngIf="uhfSettings.languageSection" 
                tabindex="0" 
                [attr.aria-label]="localeTexts[1].webAccessibility.language + ': ' + currentLang"
                [attr.aria-expanded]="languagetooltip"
            >
                <!-- Language -->
                <i class="material-icons ico" aria-hidden='true'>language</i>
                <span class="text-item" aria-hidden='true'>{{currentLang}}</span>
                <i class="material-icons down" aria-hidden='true'>arrow_drop_down</i>
            </span>
            <div *ngIf="languagetooltip" class="lang-tooltiptext">
                    <div class="lang-tooltip-padding">
                        <div class="currency-div">
                            <div class="lang-item-padding lang-font-wg title">{{localeTexts[1].main.language}}</div>
                            <div *ngFor="let item of sortedLangArr;let i=index" class="">
                                <div id="{{'langDrop'+i}}" tabindex="0" class="row s12 m12 l12 lang-list-item" (keydown)="changeLocale($event,item.code,i)" (click)="changeLocale($event,item.code,i)">
                                    <span>{{item.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <span 
                id="currDrop" 
                class="item curr" 
                #currElem 
                (click)="listenersLangCurrLogin($event,'curr')" 
                (keydown)="listenersLangCurrLogin($event,'curr')" 
                *ngIf="uhfSettings.currencySection" 
                tabindex="0" 
                [attr.aria-label]="localeTexts[1].webAccessibility.currency + ': ' + currentCurr"
                [attr.aria-expanded]="currencytooltip"
            >
                <!-- Currency -->
                <span class="text-item" aria-hidden='true'>{{currentCurr}}</span>
                <i class="material-icons down" aria-hidden='true'>arrow_drop_down</i>
            </span>
            <div *ngIf="currencytooltip" class="currency-tooltiptext">
                    <div class="lang-tooltip-padding">
                        <div class="currency-div">
                            <div class="lang-item-padding lang-font-wg title">{{localeTexts[1].main.currency}}</div>
                            <div *ngFor="let item of sortedLangKeys;let i=index">
                                <div id="{{'currDrop'+i}}" tabindex="0" class="row s12 m12 l12 currencylist-item" (keydown)="changeCurrency($event,item,i)" (click)="changeCurrency($event,item,i)">
                                    <div class="col s3 m3 l3">
                                        <span class="lang-font-wg">{{item}}</span>
                                    </div>
                                    <div class="col s9 m9 l9">
                                        <span>{{localeTexts[3].currency[item]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <div class="sep s2" *ngIf="uhfSettings.loginSection" [ngClass]="clz1"></div>

        <div #loginElem class="login" *ngIf="uhfSettings.loginSection" [ngClass]="clz1">

            <i class="material-icons ico" (click)="listenersLangCurrLogin($event,'login')" [ngClass]="{ 'iconcolorlogin' : loggedIn, 'iconcolorsignup' : !loggedIn}">person</i>
            <span id="loginModal" *ngIf="!loggedIn" class="text-item" (click)="openSsoLogin()" (keydown)="onEnterOpenModal($event)" tabindex="0">
                <mat-spinner *ngIf="!loginText" [diameter]="20" style="position: absolute; top: 13px; left: 35px;"></mat-spinner>
                {{loginText}}
            </span>
            <span id="loginModal" *ngIf="loggedIn" class="text-item capitalize" (click)="listenersLangCurrLogin($event,'login')" (keydown)="listenersLangCurrLogin($event,'login')" tabindex="0">{{userName}}</span>

            <div class="tooltiptext" *ngIf="loggedIn && logintooltip">
                <div class="web-logout-background">
                    <div class="row s12 m12 l12 tooltip-padding">
                        <div class="col s5 m5 l5">
                            <span>{{localeTexts[1].main.bigMemberID}}</span>
                        </div>
                        <div class="col s7 m7 l7">
                            <span class="custom-font">{{bigMemberId}}</span>
                        </div>
                    </div>
                    <div class="row s12 m12 l12 tooltip-padding">
                        <div class="col s5 m5 l5">
                            <span>{{localeTexts[1].main.bigPoints}}</span>
                        </div>
                        <div class="col s7 m7 l7">
                            <span class="custom-font">{{bigPointsBalance}}</span>
                            <span>
                                <img class="refresh-icon" src="https://b.staticaa.com/images/misc/refresh-icon.png" alt="refresh icon" (click)="refreshBigPoints(true)">
                            </span>
                        </div>
                    </div>
                    <div class="row s12 m12 l12 tooltip-padding">
                        <div class="col s5 m5 l5">
                            <span>{{localeTexts[1].main.status}}</span>
                        </div>
                        <div class="col s7 m7 l7">
                            <span class="custom-font">
                                <img src="{{bigStatusImgUrl}}" alt="status">
                            </span>
                        </div>
                    </div>

                </div>

                <mat-nav-list class="">
                    <div>
                        <a mat-list-item *ngFor="let item of localeTexts[4].mainNav[0].content; let i = index" href="{{item.url}}" target="{{item.newTab == 'TRUE' ? '_blank' : ''}}">
                            <span>
                                <a >
                                    <div class="row row-width">
                                        <div class="col icon-col">
                                            <mat-icon class="icon-color">{{item.icon}}</mat-icon>
                                        </div>
                                        <div class="col icon-des">
                                            <span class="text-size">{{item.text}}</span>
                                        </div>
                                    </div>
                                </a>
                            </span>
                        </a>
                    </div>
                </mat-nav-list>
                <hr class="hr-color">
                <div class="row logout">
                    <button id="logout" (click)="logoutWidget()">{{localeTexts[1].main.logout}}</button>
                </div>
            </div>

        </div>
    </div>
</div>

<div id="login-signup" *ngIf="isDesktop" class="sso-modal font-weight" (mousedown)="closeModal($event)" tabindex="-1">
    <div class="main">
        <aa-sso-widget (openSsoModal)='openmodel($event)' (closeSsoModal)='closeModal($event)' [isMobileView]='false'></aa-sso-widget>
    </div>
</div>
<!-- <div id="login-only" class="sso-modal font-weight" (click)="closeModal($event)" tabindex="-1">
    <div class="main">
        <aa-sso-widget></aa-sso-widget>
      </div>
</div> -->

